/**
 * Tenant GL system `surrogateKey`: pipe-separated first-row header tokens (e.g. GL_CODE|TRANSACTION_TYPE).
 */
export const splitSurrogateKeyTokens = (surrogateKeyRaw) => {
  const s = String(surrogateKeyRaw || '').trim();
  if (!s) return [];
  return s
    .split('|')
    .map((p) => p.trim())
    .filter((p) => p.length > 0);
};
